import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

enum PartnerCompaniesTypeEnum {
  MOTHER = 'Mother',
  CHILD = 'Child',
}

type PartnerCompaniesType = Record<PartnerCompaniesTypeEnum, string>;

const PARTNER_COMPANIES_TYPE_NAME: PartnerCompaniesType = {
  [PartnerCompaniesTypeEnum.MOTHER]: 'Mãe',
  [PartnerCompaniesTypeEnum.CHILD]: 'Filho',
};

const PARTNER_COMPANIES_TYPE_COLOR: PartnerCompaniesType = {
  [PartnerCompaniesTypeEnum.MOTHER]: NEW_COLORS.SEMANTICS.WARNING[500],
  [PartnerCompaniesTypeEnum.CHILD]: NEW_COLORS.SEMANTICS.INFO[800],
};

const PARTNER_COMPANIES_TYPE_TEXT_COLOR: PartnerCompaniesType = {
  [PartnerCompaniesTypeEnum.MOTHER]: NEW_COLORS.GRAYSCALE[700],
  [PartnerCompaniesTypeEnum.CHILD]: NEW_COLORS.BASE.WHITE,
};

export {
  PARTNER_COMPANIES_TYPE_NAME,
  PARTNER_COMPANIES_TYPE_COLOR,
  PARTNER_COMPANIES_TYPE_TEXT_COLOR,
  PartnerCompaniesTypeEnum,
};
